// extracted by mini-css-extract-plugin
export default {"selectIndex":"select-index_selectIndex__kXZg3"};